import CardImage from "./components/CardImage.js";
import CardLink from "./components/CardLink.js";
import CardWidget from "./components/CardWidget.js";
import CardsContainer from "./components/CardsContainer.js";
import DeckSampleHand from "./components/DeckSampleHand.js";
import DeckStatsColors from "./components/DeckStatsColors.js";
import DeckStatsManaValues from "./components/DeckStatsManaValues.js";
import DeckStatsTypes from "./components/DeckStatsTypes.js";
// import GradedCardListings from "./components/GradedCardListings.js";
import TierList from "./components/TierList.js";

export default {
  CardImage,
  CardLink,
  CardWidget,
  CardsContainer,
  DeckSampleHand,
  DeckStatsColors,
  DeckStatsManaValues,
  DeckStatsTypes,
  // GradedCardListings,
  TierList,
};

// need to do this so the names still resolved after --minify
window.CardImage = CardImage
window.CardLink = CardLink
window.CardWidget = CardWidget
window.CardsContainer = CardsContainer
window.DeckSampleHand = DeckSampleHand
window.DeckStatsColors = DeckStatsColors
window.DeckStatsManaValues = DeckStatsManaValues
window.DeckStatsTypes = DeckStatsTypes
// window.GradedCardListings = GradedCardListings
window.TierList = TierList
